import { render, staticRenderFns } from "./backgroundCheck.vue?vue&type=template&id=89d55dcc&scoped=true&"
import script from "./backgroundCheck.vue?vue&type=script&lang=js&"
export * from "./backgroundCheck.vue?vue&type=script&lang=js&"
import style0 from "./backgroundCheck.vue?vue&type=style&index=0&id=89d55dcc&prod&scoped=true&lang=scss&"
import style1 from "./backgroundCheck.vue?vue&type=style&index=1&id=89d55dcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d55dcc",
  null
  
)

export default component.exports